export enum MessageType {
  WARNING,
  ERROR,
  SUCCESS
}
export namespace MessageType {
  export const isWarning = (input: MessageType) => {
    return input === MessageType.WARNING;
  }
  export const isError = (input: MessageType) => {
    return input === MessageType.ERROR;
  }
  export const isSuccess = (input: MessageType) => {
    return input === MessageType.SUCCESS;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/message/message-type.model.ts